<template>
  <div>
    <div class="table-responsive">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4
          style="
            font-family: &quot;Roboto&quot;;
            font-style: normal;
            font-weight: 500;
            font-size: 20px;
            line-height: 24px;
            display: flex;
            align-items: center;
            color: #333333;
          "
        >
          {{ $t("message.account.users") }}
        </h4>
        <button
          class="btn btn-sm btn-primary"
          style="height: 40px; padding-top: 10px; padding-bottom: 10px"
          v-b-modal.modal-add-team-member
        >
          {{ $t("message.account.team_add_user") }}
          <svg
            width="18"
            height="18"
            class="ml-1"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.9993 8.08696C15.9993 9.30156 15.4882 10.8877 14.6011 12.1606C13.6856 13.4743 12.7125 14 11.9993 14C11.2862 14 10.313 13.4743 9.39755 12.1606C8.51048 10.8877 7.99933 9.30156 7.99933 8.08696C7.99933 5.80256 9.81722 4 11.9993 4C14.1814 4 15.9993 5.80256 15.9993 8.08696ZM14.56 15.0779C13.7834 15.6522 12.9153 16 11.9993 16C11.0833 16 10.2153 15.6522 9.43865 15.0779L8.86567 15.188C7.32689 15.4835 6.03342 16.52 5.40968 17.9574C4.99103 18.9222 5.69823 20 6.74994 20H17.2487C18.3004 20 19.0076 18.9222 18.589 17.9574C17.9652 16.52 16.6718 15.4835 15.133 15.188L14.56 15.0779ZM16.1821 13.389C17.303 11.8184 17.9993 9.7985 17.9993 8.08696C17.9993 4.72522 15.313 2 11.9993 2C8.68562 2 5.99933 4.72522 5.99933 8.08696C5.99933 9.7985 6.69564 11.8184 7.81655 13.389C5.92779 13.9574 4.36934 15.3307 3.57497 17.1613C2.58321 19.4468 4.25851 22 6.74994 22H17.2487C19.7402 22 21.4154 19.4468 20.4237 17.1613C19.6293 15.3307 18.0709 13.9574 16.1821 13.389Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
      <div class="py-5 my-5" v-if="loading">
        <div class="loading"></div>
      </div>
      <b-table
        :fields="fields"
        :items="joint_items"
        :tbody-tr-class="rowClass"
        v-if="!loading"
      >
        <template v-slot:cell(first_name)="data">
          <div>{{ data.value }}</div>
          <span v-if="data.item.is_admin" class="badge bg-warning"
            >администратор</span
          >
        </template>
        <template v-slot:cell(action)="data">
          <div class="btn-group btn-group-sm">
            <button
              @click="editUser(data.item)"
              v-if="!data.item.is_admin"
              class="btn text-secondary px-2"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.2071 4.20733C17.4174 3.99704 17.7026 3.87891 18 3.87891C18.1473 3.87891 18.2931 3.90791 18.4291 3.96426C18.5652 4.02061 18.6888 4.10321 18.7929 4.20733C18.897 4.31146 18.9796 4.43507 19.036 4.57112C19.0923 4.70716 19.1213 4.85297 19.1213 5.00023C19.1213 5.14748 19.0923 5.29329 19.036 5.42934C18.9796 5.56538 18.897 5.68899 18.7929 5.79312L8.50001 16.086L6.91422 14.5002L17.2071 4.20733ZM5.50001 15.9145L4.90298 16.5115L4.37439 18.6259L6.48877 18.0973L7.08579 17.5002L5.50001 15.9145ZM18 1.87891C17.1722 1.87891 16.3783 2.20776 15.7929 2.79312L3.29291 15.2931C3.16476 15.4213 3.07384 15.5819 3.02988 15.7577L2.02988 19.7577C1.94468 20.0985 2.04453 20.459 2.29291 20.7073C2.54129 20.9557 2.90178 21.0556 3.24256 20.9704L7.24256 19.9704C7.41839 19.9264 7.57897 19.8355 7.70713 19.7073L20.2071 7.20733C20.497 6.91749 20.7269 6.5734 20.8837 6.1947C21.0406 5.81601 21.1213 5.41012 21.1213 5.00023C21.1213 4.59033 21.0406 4.18444 20.8837 3.80575C20.7269 3.42705 20.497 3.08296 20.2071 2.79312C19.9173 2.50328 19.5732 2.27336 19.1945 2.1165C18.8158 1.95964 18.4099 1.87891 18 1.87891Z"
                  fill="#797980"
                />
              </svg>
            </button>
            <!-- <button disabled v-if="!data.item.is_admin && data.item.active==0" class="btn btn-sm btn-secondary px-2"><i class="fa fa-edit"></i></button> -->
            <button
              @click="deleteUser(data.item)"
              v-if="!data.item.is_admin && data.item.active == 1"
              class="btn btn-sm px-2"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 15C10 14.4477 10.4477 14 11 14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H11C10.4477 16 10 15.5523 10 15Z"
                  fill="#47B2E4"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6 2C8.20914 2 10 3.79086 10 6V8H16C18.7614 8 21 10.2386 21 13V17C21 19.7614 18.7614 22 16 22H8C5.23858 22 3 19.7614 3 17V13C3 10.2386 5.23858 8 8 8V6C8 4.89543 7.10457 4 6 4C4.89543 4 4 4.89543 4 6V6.5H2V6C2 3.79086 3.79086 2 6 2ZM8 10C6.34315 10 5 11.3431 5 13V17C5 18.6569 6.34315 20 8 20H16C17.6569 20 19 18.6569 19 17V13C19 11.3431 17.6569 10 16 10H8Z"
                  fill="#47B2E4"
                />
              </svg>
            </button>
            <button
              @click="deleteUser(data.item)"
              v-if="!data.item.is_admin && data.item.active == 0"
              class="btn btn-sm px-2"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="4"
                  y="9"
                  width="16"
                  height="12"
                  rx="4"
                  stroke="#797980"
                  stroke-width="2"
                />
                <path
                  d="M12 16L12 14"
                  stroke="#797980"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16 10V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7L8 10"
                  stroke="#797980"
                  stroke-width="2"
                />
              </svg>
            </button>
          </div>
        </template>
      </b-table>
    </div>

    <b-modal
      id="modal-add-team-member"
      centered
      :hide-footer="true"
      size="md"
      :title="$t('message.account.team_add_user')"
    >
      <form @submit.prevent="addUser">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="position">{{
                $t("message.account.team_position")
              }}</label>
              <input
                type="text"
                id="position"
                v-model="new_item.position"
                required
                :placeholder="$t('message.reg_form.position_placeholder_user')"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="last_name">{{
                $t("message.account.team_last_name")
              }}</label>
              <input
                type="text"
                id="last_name"
                v-model="new_item.last_name"
                :placeholder="
                  $t('message.reg_form.first_name_placeholder_user')
                "
                required
                class="form-control"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="first_name">{{
                $t("message.account.team_first_name")
              }}</label>
              <input
                type="text"
                id="first_name"
                v-model="new_item.first_name"
                required
                :placeholder="$t('message.reg_form.last_name_placeholder_user')"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="phone">{{ $t("message.account.team_phone") }}</label>
              <input
                type="text"
                id="phone"
                v-model="new_item.phone"
                placeholder="+7 999 123 45 67"
                required
                class="form-control"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="email">{{ $t("message.account.team_email") }}</label>
              <input
                type="email"
                id="email"
                v-model="new_item.email"
                placeholder="youremail@company.ru"
                required
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="password">{{
                $t("message.account.team_password")
              }}</label>
              <input
                type="text"
                id="password"
                v-model="new_item.tmp_password"
                required
                :placeholder="$t('message.reg_form.password_placeholder')"
                class="form-control"
              />
              <div class="form-desc">
                {{ $t("message.reg_form.customer_password_placeholder") }}
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="modal_error !== ''">
          <div class="col-12">
            <div class="alert alert-danger rounded">
              {{ modal_error }}
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="w-100 col-12 form-button-group d-flex justify-content-end gap-20"
          >
            <button
              class="btn btn-outline-secondary"
              @click="$bvModal.hide('modal-add-team-member')"
            >
              {{ $t("message.cancel") }}
            </button>
            <button class="btn btn-primary">{{ $t("message.save") }}</button>
          </div>
          <!-- <div class="col-12 d-flex justify-content-end">
                        <button class="btn btn-success">{{ $t('message.account.team_add_user') }}</button>
                    </div> -->
        </div>
      </form>
    </b-modal>
    <b-modal
      id="modal-edit-team-member"
      centered
      :hide-footer="true"
      size="md"
      :title="$t('message.account.team_edit_user')"
    >
      <form @submit.prevent="updateUser">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="position">{{
                $t("message.account.team_position")
              }}</label>
              <input
                type="text"
                id="position"
                v-model="edit_item.position"
                required
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="first_name">{{
                $t("message.account.team_first_name")
              }}</label>
              <input
                type="text"
                id="first_name"
                v-model="edit_item.first_name"
                required
                class="form-control"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="last_name">{{
                $t("message.account.team_last_name")
              }}</label>
              <input
                type="text"
                id="last_name"
                v-model="edit_item.last_name"
                required
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="phone">{{ $t("message.account.team_phone") }}</label>
              <input
                type="text"
                id="phone"
                v-model="edit_item.phone"
                placeholder="+7 000 000 00 00"
                required
                class="form-control"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="email">{{ $t("message.account.team_email") }}</label>
              <input
                type="email"
                id="email"
                v-model="edit_item.email"
                required
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row" v-if="modal_error !== ''">
          <div class="col-12">
            <div class="alert alert-danger rounded">
              {{ modal_error }}
            </div>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-12 d-flex justify-content-end">
                        <button class="btn btn-success">{{ $t('message.account.team_edit_user') }}</button>
                    </div> -->
          <div
            class="w-100 col-12 form-button-group d-flex justify-content-end gap-20"
          >
            <button
              class="btn btn-outline-secondary"
              @click="$bvModal.hide('modal-edit-team-member')"
            >
              {{ $t("message.cancel") }}
            </button>
            <button class="btn btn-primary">
              {{ $t("message.account.team_edit_user") }}
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      modal_error: "",
      new_item: {
        position: "",
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        tmp_password: "",
      },
      edit_item: {
        position: "",
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        tmp_password: "",
      },
      items: [],
      fields: [
        // {
        //     key: 'id',
        //     label: this.$t('message.account.team_id'),
        // },
        {
          key: "first_name",
          label: this.$t("message.account.team_first_name"),
        },
        {
          key: "last_name",
          label: this.$t("message.account.team_last_name"),
        },
        {
          key: "position",
          label: this.$t("message.account.team_position"),
        },
        {
          key: "email",
          label: this.$t("message.account.team_email"),
        },
        {
          key: "phone",
          label: this.$t("message.account.team_phone"),
        },
        // {
        //     key: 'is_admin',
        //     label: '',
        // },

        {
          key: "action",
          label: "",
        },
      ],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    rowClass(item, type) {
      return "";
      if (item.active == 0) {
        return "bg-light";
      }
    },
    load() {
      this.loading = true;
      axios.get(window.base + "/account/loadTeamUsers").then((response) => {
        this.loading = false;
        if (response.data !== "") this.items = response.data;
      });
    },
    addUser() {
      axios
        .post(window.base + "/account/createTeamUser", this.new_item)
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.load();
            this.$bvModal.hide("modal-add-team-member");
          } else {
            this.modal_error = response.data.statusMessage;
          }
        });
    },
    editUser(data) {
      this.edit_item = data;
      this.$bvModal.show("modal-edit-team-member");
    },
    updateUser() {
      axios
        .post(window.base + "/account/UpdateTeamUser", this.edit_item)
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.load();
            this.$bvModal.hide("modal-edit-team-member");
          } else {
            this.modal_error = response.data.statusMessage;
          }
        });
    },
    deleteUser(data) {
      if (data.active == 0) {
        this.$bvModal
          .msgBoxConfirm(this.$t("message.account.team_active_confirm"), {
            title: this.$t("message.confirm"),
            size: "md",
            buttonSize: "sm",
            okVariant: "info",
            okTitle: this.$t("message.yes"),
            cancelTitle: this.$t("message.no"),
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              axios
                .post(window.base + "/account/deleteTeamUser", {
                  id: data.id,
                })
                .then(() => {
                  this.load();
                });
            }
          });
      } else {
        this.$bvModal
          .msgBoxConfirm(this.$t("message.account.team_remove_confirm"), {
            title: this.$t("message.confirm"),
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: this.$t("message.yes"),
            cancelTitle: this.$t("message.no"),
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              axios
                .post(window.base + "/account/deleteTeamUser", {
                  id: data.id,
                })
                .then(() => {
                  this.load();
                });
            }
          });
      }
    },
  },
  computed: {
    joint_items() {
      return [
        {
          id: this.$store.state.firmfull.persons.user_id,
          is_admin: true,
          email: this.$store.state.firmfull.persons.person_email,
          phone: this.$store.state.firmfull.persons.person_code,
          position: this.$store.state.firmfull.persons.position,
          first_name: this.$store.state.user.firstName,
          last_name: this.$store.state.user.lastName,
        },
      ].concat(this.items);
    },
  },
};
</script>
<style scoped>
input.form-control::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #ccc;
}
input.form-control::-moz-placeholder {
  /* Firefox 19+ */
  color: #ccc;
}
input.form-control:-ms-input-placeholder {
  /* IE 10+ */
  color: #ccc;
}
input.form-control:-moz-placeholder {
  /* Firefox 18- */
  color: #ccc;
}
.badge.bg-warning {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */
  height: 16px;
  display: inline-flex;
  align-items: center;
  text-align: center;

  /* primary100 */

  color: #ffffff;

  /* primary/primary */

  background: #fe5000 !important;
  border-radius: 12px;
}
.form-desc {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* neutral/10 */

  color: #333333;
}
</style>
